import { createSlice } from '@reduxjs/toolkit';


const isValidUniqueId = (id) =>
  typeof id === 'string' && /^[a-z]+_\d+$/.test(id);  

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState: { items: [] },
  reducers: {
    toggleFavorite: (state, action) => {
      const uniqueId = action.payload;
      if (!isValidUniqueId(uniqueId)) return;  // Ignore invalid IDs

      if (state.items.includes(uniqueId)) {
        state.items = state.items.filter(item => item !== uniqueId);
      } else {
        state.items.push(uniqueId);
      }

      // Purge any remaining bad entries
      state.items = state.items.filter(isValidUniqueId);
    }
  },
 
});

export const { toggleFavorite } = favoritesSlice.actions;
export default favoritesSlice.reducer;
